/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import { Col, Row, Alert } from 'react-bootstrap';
import { Button, Input } from 'appkit-react';
import 'react-phone-input-2/lib/style.css';
import '../styles/signup.scss';

const appTitle = process.env.REACT_APP_TITLE;

const SelfSignup = ({
    email,
    setEmail,
    institution,
    setInstitution,
    institutionsList,
    disableBtn,
    showErrorAlert,
    setShowErrorAlert,
    setShowSuccessAlert,
    showSuccessAlert,
    errorMsg,
    onSave,
    registerUserLoading,
    validateEmail,
    emailError,
}) => {
    const signupMessage = 'Intake Form';
    const successMessage = 'Thank you for completing the intake form. You will soon receive an invitation to complete your registration.';

    return (
        <div className="selfsignup-container">
            <div className="normal-header-container">
                <nav
                    className="a-header-wrapper justify-content-between"
                >
                    <div className="a-brand-container">
                        <div className="a-pwc-logo-grid a-md" />
                        <div className="a-divider" />
                        <span className="font-weight-medium text-nowrap">
                            {appTitle}
                        </span>
                    </div>
                </nav>
            </div>
            <Row>
                <Col md={4} className="form-wrapper">
                    <h4 className="form-heading">{signupMessage}</h4>

                    {showErrorAlert && (
                        <Alert
                            variant="danger"
                            onClose={() => setShowErrorAlert(false)}
                            dismissible
                        >
                            {errorMsg}
                        </Alert>
                    )}

                    {showSuccessAlert && (
                        <Alert
                            variant="success"
                            onClose={() => setShowSuccessAlert(false)}
                            dismissible
                        >
                            {successMessage}
                        </Alert>
                    )}

                    <div className="true-comply-register-user">
                        <form autoComplete="off">
                            <div className="form-label a-h6">EMAIL ID</div>
                            <Input type="email" name="email" value={email} onChange={setEmail} onBlur={validateEmail} />
                            {emailError && <div className="text-danger mt-1">{emailError}</div>}

                            <div className="form-label a-h6">INSTITUTION</div>
                            <input
                                list="institution-options"
                                className="form-control"
                                value={institution}
                                onChange={e => setInstitution(e.target.value)}
                                placeholder="Select or type institution"
                            />

                            <datalist id="institution-options">
                                {institutionsList.map(inst => (
                                    <option key={inst.value} value={inst.value}>
                                        {inst.label}
                                    </option>
                                ))}
                            </datalist>

                            <div className="submit-button">
                                <Button size="xl w-100" onClick={onSave} disabled={disableBtn} isLoading={registerUserLoading}>
                                    REQUEST ACCESS
                                </Button>
                            </div>
                        </form>
                    </div>
                </Col>

            </Row>
        </div>
    );
};

export default SelfSignup;
